import React from 'react';

import Box from '@ui/Box';
import { H1 } from '@ui/heading';

const PageTitle = ({ children, actionButton, mb = 6, mt = 0, alignItems = 'flex-end', sx = {} }) => {
    if (!actionButton) {
        return (
            <H1
                sx={{
                    mb,
                    mt,
                    ...sx,
                }}
            >
                {children}
            </H1>
        );
    }

    return (
        <Box sx={{ display: 'flex', alignItems: alignItems, mb, ...sx }}>
            <H1
                sx={{
                    flexGrow: 1,
                    mt,
                }}
            >
                {children}
            </H1>
            {actionButton}
        </Box>
    );
};

export default PageTitle;
